export default "__VITE_PUBLIC_ASSET__2c464cc2__"